"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageCaptcha = void 0;

var react_1 = __importStar(require("react"));

var elements_1 = require("../../elements");

var typography_1 = require("../../elements/typography");

var captcha_service_1 = require("./captcha-service");

var ImageCaptcha = function ImageCaptcha(_a) {
  var apiHost = _a.apiHost,
      value = _a.value,
      theme = _a.theme,
      captchaInput = _a.captchaInput,
      apiParcel = _a.apiParcel,
      onCaptchaChange = _a.onCaptchaChange,
      onCaptchaRefresh = _a.onCaptchaRefresh,
      _b = _a.error,
      error = _b === void 0 ? false : _b;

  var _c = (0, react_1.useState)(),
      captchaState = _c[0],
      setCaptchaState = _c[1];

  var _d = (0, react_1.useState)(),
      isLoadingState = _d[0],
      setLoadingState = _d[1];

  (0, react_1.useEffect)(function () {
    setLoadingState(true);
    (0, captcha_service_1.getCaptcha)(apiHost, value, apiParcel).then(function (res) {
      setCaptchaState(res);
      setLoadingState(false);
    });
  }, [value]);
  return react_1["default"].createElement("section", {
    className: "w-full"
  }, react_1["default"].createElement("div", {
    className: "flex flex-col md:flex-row"
  }, react_1["default"].createElement("div", {
    className: "flex w-full md:w-1/2 md:mr-2"
  }, react_1["default"].createElement("div", {
    className: "w-full"
  }, react_1["default"].createElement(elements_1.Input, {
    theme: theme,
    label: "Captcha Input",
    type: "text",
    id: "captchaInput",
    name: "captchaInput",
    value: captchaInput,
    placeholderText: "Captcha Placeholder",
    onInputChanged: function onInputChanged(captcha) {
      return onCaptchaChange(captcha);
    }
  }), react_1["default"].createElement("div", null, error && react_1["default"].createElement(typography_1.Error, {
    theme: theme
  }, "Captcha does not match!")))), react_1["default"].createElement("div", {
    className: "flex w-full justify-between md:w-1/2 md:ml-2 mt-2 md:mt-0"
  }, isLoadingState ? react_1["default"].createElement(elements_1.Spinner, {
    theme: theme
  }) : react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement("img", {
    src: "data:image/png;base64," + (captchaState ? captchaState.payload : undefined)
  }), react_1["default"].createElement("div", {
    className: "flex items-center ml-2"
  }, react_1["default"].createElement(elements_1.ButtonRegular, {
    text: "Refresh",
    size: elements_1.ButtonSize.small,
    type: elements_1.ButtonType.primary,
    onClick: onCaptchaRefresh
  }))))));
};

exports.ImageCaptcha = ImageCaptcha;